export const Chars = {
    nbsp: "\u00a0",
};
